import React, { ReactNode } from 'react';

import { theme } from 'antd';

import './TitleBar.scss';

const { useToken } = theme;
function TitleBar({
  title,
  trailing,
  children,
}: {
  title: string;
  trailing?: ReactNode;
  children?: ReactNode;
}) {
  const { token } = useToken();

  return (
    <div className="TitleBar" style={{ color: token.colorPrimary }}>
      <div className="TitleBar__title">
        {title}
        <span className="TitleBar__popover">{trailing}</span>
      </div>
      <div className="TitleBar__buttons">{children}</div>
    </div>
  );
}

export default TitleBar;
